/**
 * video-popup.js
 * Shows a video popup when ?show_video=1 is present in the URL,
 * unless the user has already closed it (tracked via cookie).
 */
(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────── */

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, seconds) {
    var expires = '';
    if (seconds) {
      var d = new Date();
      d.setTime(d.getTime() + seconds * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function hasShowParam() {
    try {
      return new URLSearchParams(window.location.search).get('show_video') === '1';
    } catch (e) {
      return window.location.search.indexOf('show_video=1') !== -1;
    }
  }

  /* ── Main ─────────────────────────────────────────────── */

  function init() {
    if (!hasShowParam()) return;

    var cfg        = window.__vpConfig || {};
    var cookieName    = cfg.cookieName    || 'vp_seen';
    var cookieSeconds = cfg.cookieSeconds != null ? cfg.cookieSeconds : 604800;

    // Already dismissed — respect user choice
    if (getCookie(cookieName)) return;

    var overlay      = document.getElementById('video-popup-overlay');
    var video        = document.getElementById('vp-video');
    var closeBtn     = document.getElementById('vp-close');
    var soundToggle  = document.getElementById('vp-sound-toggle');
    var tapIndicator = document.getElementById('vp-tap-indicator');

    if (!overlay || !video) return;

    /* Show the overlay */
    overlay.style.display = 'flex';

    /* Scroll-lock — iOS-safe: fix body in place so Safari can't scroll behind the overlay */
    var scrollY = window.scrollY || window.pageYOffset;
    document.body.style.overflow  = 'hidden';
    document.body.style.position  = 'fixed';
    document.body.style.top       = '-' + scrollY + 'px';
    document.body.style.width     = '100%';

    /* Apply initial volume from data attribute (0.0 – 1.0) */
    var vol = parseFloat(video.dataset.volume);
    video.volume = (!isNaN(vol) && vol >= 0 && vol <= 1) ? vol : 1;

    /* Attempt autoplay WITH audio first */
    video.muted = false;
    var promise = video.play();

    if (promise !== undefined) {
      promise
        .then(function () {
          // Autoplay with audio succeeded — mark button as unmuted
          if (soundToggle) soundToggle.classList.replace('is-muted', 'is-unmuted');
        })
        .catch(function () {
          // Browser blocked unmuted autoplay → fall back to muted
          video.muted = true;
          video.play().catch(function () {});
          // Button stays as is-muted (default)
        });
    }

    /* Sound toggle: mute ↔ unmute */
    if (soundToggle) {
      soundToggle.addEventListener('click', function (e) {
        e.stopPropagation(); // don't trigger video tap-to-pause
        if (video.muted) {
          video.muted = false;
          var v = parseFloat(video.dataset.volume);
          video.volume = (!isNaN(v) && v >= 0 && v <= 1) ? v : 1;
          soundToggle.classList.replace('is-muted', 'is-unmuted');
        } else {
          video.muted = true;
          soundToggle.classList.replace('is-unmuted', 'is-muted');
        }
      });
    }

    /* Tap on video to pause / resume */
    var tapTimer = null;
    video.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        if (tapIndicator) tapIndicator.classList.add('is-playing');
      } else {
        video.pause();
        if (tapIndicator) tapIndicator.classList.remove('is-playing');
      }
      // Trigger pulse animation
      if (tapIndicator) {
        tapIndicator.classList.remove('animate');
        // Force reflow so the animation restarts
        void tapIndicator.offsetWidth;
        tapIndicator.classList.add('animate');
        clearTimeout(tapTimer);
        tapTimer = setTimeout(function () {
          tapIndicator.classList.remove('animate');
        }, 700);
      }
    });

    /* Close logic */
    function closePopup() {
      overlay.style.display = 'none';
      /* Restore scroll — must read top before clearing it */
      var savedTop = parseInt(document.body.style.top || '0', 10);
      document.body.style.overflow  = '';
      document.body.style.position  = '';
      document.body.style.top       = '';
      document.body.style.width     = '';
      window.scrollTo(0, -savedTop);
      video.pause();
      video.currentTime = 0;
      setCookie(cookieName, '1', cookieSeconds);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    // Click outside the container
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    // Keyboard: Escape key
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closePopup();
        document.removeEventListener('keydown', handler);
      }
    });
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
